import React from 'react';
import { Text, Title, TitleProps } from '@gjensidige/builders-components';
import { HeaderSmallScreen } from '../../../interfaces/Types';
import classNames from 'classnames';
interface Props {
  header?: HeaderSmallScreen;
}

export type ComponentProps = Props;

export const InsuranceTileHeaderSmallScreen: React.FC<Props> = ({
  header
}: Props) => {
  return (
    <>
      <div className="small-screen-package-header">
        <Title as={"h3" as TitleProps['as']} size="4" className={`${header?.monthlyPrice && header?.priceLabel ? '' : 'disabled-package'}`}>{header?.packageTitle}</Title>
        <div className="small-screen-price">
          {header?.monthlyPrice && header?.priceLabel ? (
            <>
              <Text size="lead" weight="700">{header?.priceLabel}</Text>
              <Text size="body" className="mb-1 small-screen-freq">
                {` / mån`}
              </Text>
            </>
          ) :
            (
              <Title as={"h3" as TitleProps['as']} className='disabled-package'>-</Title>
            )}
        </div>

        {header?.monthlyPrice && header?.priceLabel && header.oldPriceLabel && (
          <div className="d-flex">
            <Text size="body" className="mb-1 stike-package-label-small-screen">
              {header.oldPriceLabel}
            </Text>
          </div>
        )}
        {header?.priceLabel && header?.monthlyPrice &&
          header?.packageInfos.map((info: string, index: number) => {
            if (info) {
              return (
                <Text
                  className={`${header?.packageInfos.length > 1
                      ? header?.packageInfos.length === index + 1
                        ? 'pt-1'
                        : 'highlight-text'
                      : ''
                    }`}
                  size="body"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: info }}
                ></Text>
              );
            }
            return null;
          })}
      </div>
    </>
  );
};
